import React, { useEffect, useState, useMemo } from 'react';
import { debounceFunction, Input } from '@prio365/prio365-react-library';

type DebouncedInputProps = Omit<
  React.ComponentProps<typeof Input>,
  'onChange'
> & {
  onChange?: (value: string) => void;
  debounceMs?: number;
  full?: boolean;
};

const DebouncedInput: React.FC<DebouncedInputProps> = (props) => {
  //#region ------------------------------ Defaults
  const { onChange, debounceMs = 150, full = true, ...rest } = props;
  //#endregion

  //#region ------------------------------ States / Attributes / Selectors
  const [innerValue, setInnerValue] = useState<string>('');
  //#endregion

  //#region ------------------------------ Methods / Handlers
  const debouncedInputChange = useMemo(
    () =>
      debounceFunction((value: string, cb?: (value: string) => void) => {
        if (cb) cb(value);
      }, debounceMs),
    [debounceMs]
  );

  const handleOnChange = (newValue: string) => {
    setInnerValue(newValue);
    debouncedInputChange(newValue, onChange);
  };
  //#endregion

  //#region ------------------------------ Effects
  useEffect(() => {
    setInnerValue((props.value as string) ?? '');
  }, [props.value]);
  //#endregion

  return (
    <Input {...rest} value={innerValue} onChange={handleOnChange} full={full} />
  );
};

export default DebouncedInput;
